export const msalConfig = {
  auth: {
    clientId: "dc62efc0-da23-4a1d-9bf5-4eac5bec9d40",
    authority:
      "https://login.microsoftonline.com/f446e54c-2850-4162-b08b-b2e4a37d740d", // This is a URL (e.g. https://login.microsoftonline.com/{your tenant ID})
    redirectUri: "https://edocument-dev.lsat.vn/sso/callback",
  },
  cache: {
    cacheLocation: "sessionStorage", // This configures where your cache will be stored
    storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
  },
};

// Add scopes here for ID token to be used at Microsoft identity platform endpoints.
export const loginRequest = {
  scopes: ["User.Read"],
};

// Add the endpoints here for Microsoft Graph API services you'd like to use.
export const graphConfig = {
  graphMeEndpoint: "https://graph.microsoft.com/v1.0/me",
};
